import styled from 'styled-components';

export const StickyContainer = styled.div<{ offsetTop: number; zIndex?: number }>`
  position: sticky;
  width: 100%;
  top: ${({ offsetTop }) => offsetTop}px;
  z-index: ${({ zIndex }) => (zIndex ? zIndex : 'inherit')};
`;
